import { ScrollArea, Stack } from "@mantine/core"

const DashboardTabContainer: React.FC<React.PropsWithChildren> = ({
  children,
}: React.PropsWithChildren) => {
  return (
    <ScrollArea
      h="90%"
      type="never"
      bg="gray.0"
      px="var(--tfg-organism-padding-x)"
      py="var(--tfg-organism-padding-y)"
    >
      <Stack
        py="var(--tfg-organism-padding-y)"
        gap="var(--tfg-organism-padding-y)"
      >
        {children}
      </Stack>
    </ScrollArea>
  )
}

export default DashboardTabContainer
